module.exports = __webpack_public_path__ + "img/pd_b1_img2.02c764e6.png";